<template>
  <button v-if="ativo == true" @click="onClick" class="botao-atalhos" :disabled="disabled">
    <spring-spinner v-if="loading" :animation-duration="3000" :size="20" color="#FF920D" />
    Carregar Mais
  </button>
</template>

<script>
import { SpringSpinner } from 'epic-spinners';

export default {
  name: 'BotaoCarregar',
  components: {
    SpringSpinner,
  },
  props: {
    onClick: {
      type: Function,
      default: () => {},
    },
    ativo: {
      type: Boolean,
      default: false,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.botao-atalhos {
  @extend %flex;
  @extend %align-items-center;
  @extend %justify-center;
  @extend %direction-row;
  @extend %nao-selecionavel;
  cursor: pointer;
  border-radius: 10px;
  text-decoration: none;
    font-family: 'VivoType';
  font-weight: bold;
  text-transform: uppercase;
  font-size: 20px;
  letter-spacing: 0px;
  color: $cor_primaria;
  background: $cor_cinza_40;
  width: 100%;
  padding: 15px 0px;
  margin: 30px 0px 40px;
  outline: none;
  border: 0;

  &:hover {
    color: white;
    background: $cor_primaria;
    -webkit-box-shadow: 0px 10px 30px 1px rgba(102, 0, 153, 0.35);
    -moz-box-shadow: 0px 10px 30px 1px rgba(102, 0, 153, 0.35);
    box-shadow: 0px 10px 30px 1px rgba(102, 0, 153, 0.35);
  }
  &:disabled {
    color: white;
    background: $cor_primaria;
    -webkit-box-shadow: 0px 10px 30px 1px rgba(102, 0, 153, 0.35);
    -moz-box-shadow: 0px 10px 30px 1px rgba(102, 0, 153, 0.35);
    box-shadow: 0px 10px 30px 1px rgba(102, 0, 153, 0.35);
  }

  & .spring-spinner {
    margin-right: 10px;
  }
}
</style>
